<div class="outer-container" [ngClass]="{'disabled': disabled}">

  <button mat-stroked-button
    class="switch-to-page-button"
    (click)="onClickPrevPage()"
    [ngClass]="{'disabled': disabled || (prevPage === null)}">
    <span><i class="far fa-arrow-left"></i></span>
  </button>

  @if (firstPageButtonVisible()) {
    <button mat-stroked-button
      class="switch-to-page-button"
      (click)="onClickChangeToPage(1)"
      [ngClass]="{'disabled': disabled}">
      <span>1</span>
    </button>
  }

  @if (firstPageButtonSeparatorVisible()) {
    <span>...</span>
  }

  @for (pg of pages; track pg) {
    @if (pg === page) {
      <button mat-stroked-button
        class="current-page-button"
        [disabled]="true"
        color="primary">
        <span>{{ pg }}</span>
      </button>
    } @else {
      <button mat-stroked-button
        class="switch-to-page-button"
        (click)="onClickChangeToPage(pg)"
        [ngClass]="{'disabled': disabled}">
        <span>{{ pg }}</span>
      </button>
    }
  }

  <button mat-stroked-button
    class="switch-to-page-button"
    (click)="onClickNextPage()"
    [ngClass]="{'disabled': disabled || (nextPage === null)}">
    <span><i class="far fa-arrow-right"></i></span>
  </button>

</div>
